/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckRecogniseDocumentResult } from './PaxCheckRecogniseDocumentResult';
import {
    PaxCheckRecogniseDocumentResultFromJSON,
    PaxCheckRecogniseDocumentResultFromJSONTyped,
    PaxCheckRecogniseDocumentResultToJSON,
    PaxCheckRecogniseDocumentResultToJSONTyped,
} from './PaxCheckRecogniseDocumentResult';
import type { PaxCheckRecogniseDocumentResponseError } from './PaxCheckRecogniseDocumentResponseError';
import {
    PaxCheckRecogniseDocumentResponseErrorFromJSON,
    PaxCheckRecogniseDocumentResponseErrorFromJSONTyped,
    PaxCheckRecogniseDocumentResponseErrorToJSON,
    PaxCheckRecogniseDocumentResponseErrorToJSONTyped,
} from './PaxCheckRecogniseDocumentResponseError';

/**
 * 
 * @export
 * @interface PaxCheckRecogniseDocumentResponse
 */
export interface PaxCheckRecogniseDocumentResponse {
    /**
     * 
     * @type {PaxCheckRecogniseDocumentResult}
     * @memberof PaxCheckRecogniseDocumentResponse
     */
    data?: PaxCheckRecogniseDocumentResult;
    /**
     * 
     * @type {PaxCheckRecogniseDocumentResponseError}
     * @memberof PaxCheckRecogniseDocumentResponse
     */
    error?: PaxCheckRecogniseDocumentResponseError;
}

/**
 * Check if a given object implements the PaxCheckRecogniseDocumentResponse interface.
 */
export function instanceOfPaxCheckRecogniseDocumentResponse(value: object): value is PaxCheckRecogniseDocumentResponse {
    return true;
}

export function PaxCheckRecogniseDocumentResponseFromJSON(json: any): PaxCheckRecogniseDocumentResponse {
    return PaxCheckRecogniseDocumentResponseFromJSONTyped(json, false);
}

export function PaxCheckRecogniseDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRecogniseDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckRecogniseDocumentResultFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckRecogniseDocumentResponseErrorFromJSON(json['error']),
    };
}

export function PaxCheckRecogniseDocumentResponseToJSON(json: any): PaxCheckRecogniseDocumentResponse {
    return PaxCheckRecogniseDocumentResponseToJSONTyped(json, false);
}

export function PaxCheckRecogniseDocumentResponseToJSONTyped(value?: PaxCheckRecogniseDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckRecogniseDocumentResultToJSON(value['data']),
        'error': PaxCheckRecogniseDocumentResponseErrorToJSON(value['error']),
    };
}

